import { useState, useEffect } from 'react';

export const useScroll = () => {
  const [isScrolled, setScrollTop] = useState(false);
  const handleScroll = () => setScrollTop(window.scrollY > 100);
  const win = typeof window !== 'undefined' ? window : undefined;
  useEffect(() => {
    win?.addEventListener('scroll', handleScroll);
    return () => {
      win?.removeEventListener('scroll', handleScroll);
    };
  }, [win]);
  return { isScrolled, scrollY: win?.scrollY };
};
